import React, { useState } from 'react'
import { Briefcase, Plus, MapPin, DollarSign, Users, Calendar, Eye, Download, Video, FileText, Clock, CheckCircle, Search, Filter, ChevronDown, X } from 'lucide-react'
import Modal from '../../components/common/Modal'
import toast from 'react-hot-toast'

const JobPosting = () => {
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [interviewModalOpen, setInterviewModalOpen] = useState(false)

  const receivedRequests = [
    {
      id: 1,
      job_description: 'Looking for a Senior React Developer with 5+ years of experience in building scalable web applications. Must be proficient in Redux, TypeScript, and Tailwind CSS.',
      duration: '6 months',
      budget: 50,
      interview_rounds: 2,
      rounds: [
        { name: 'Technical Round 1', duration: '1 hour' },
        { name: 'System Design', duration: '45 mins' }
      ],
      selectedResources: [
        { id: 'r1', name: 'Vardhan', designation: 'Senior React Dev', cost_per_hour: 45, image: null },
        { id: 'r2', name: 'Akhil', designation: 'Frontend Lead', cost_per_hour: 55, image: null }
      ],
      availabilities: [
        { date: '2024-02-05', time: '10:00' },
        { date: '2024-02-06', time: '14:00' }
      ],
      status: 'Pending',
      created_at: '2024-01-20',
      role: 'React Developer',
      technologies: ['Redux', 'TypeScript', 'Tailwind CSS']
    },
    {
      id: 2,
      job_description: 'Need a Product Manager to lead our mobile app development team. Experience in agile methodologies and user research is required.',
      duration: '12 months',
      budget: 70,
      interview_rounds: 3,
      rounds: [
        { name: 'Intro', duration: '30 mins' },
        { name: 'Product Sense', duration: '1 hour' },
        { name: 'Behavioral', duration: '45 mins' }
      ],
      selectedResources: [
        { id: 'r3', name: 'Arjun', designation: 'Java fullStack Dev', cost_per_hour: 45, image: null },
        { id: 'r4', name: 'Maya', designation: 'UI Developer', cost_per_hour: 58, image: null }
      ],
      availabilities: [
        { date: '2026-02-10', time: '11:00' },
        { date: '2026-03-10', time: '14:00' }
      ],
      status: 'Pending',
      created_at: '2026-01-22',
      role: 'Product Manager',
      technologies: ['Agile', 'User Research']
    },
    {
      id: 3,
      job_description: 'Backend Python Developer needed for API development. FastAPI and PostgreSQL experience is a must.',
      duration: '3 months',
      budget: 40,
      interview_rounds: 1,
      rounds: [
        { name: 'Technical Assessment', duration: '1.5 hours' }
      ],
      selectedResources: [
        { id: 'r3', name: 'Navaneeth', designation: 'Backend Dev', cost_per_hour: 38, image: null }
      ],
      availabilities: [

        { date: '2026-03-10', time: '14:00' }
      ],
      status: 'Pending',
      created_at: '2026-01-25',
      role: 'Python Developer',
      technologies: ['FastAPI', 'PostgreSQL']
    },
    {
      id: 4,
      job_description: 'UI/UX Designer to revamp our corporate website. Portfolio required.',
      duration: '4 months',
      budget: 45,
      interview_rounds: 2,
      rounds: [
        { name: 'Portfolio Review', duration: '45 mins' },
        { name: 'Design Challenge', duration: '1 hour' }
      ],
      selectedResources: [
        { id: 'r1', name: 'Dinesh', designation: 'Senior Angular Dev', cost_per_hour: 85, image: null },
        { id: 'r2', name: 'Ramoji', designation: 'Frontend Lead', cost_per_hour: 55, image: null }
      ],
      availabilities: [
        { date: '2026-02-15', time: '09:00' },
        { date: '2026-02-16', time: '15:00' }
      ],
      status: 'Accepted',
      created_at: '2024-01-28',
      role: 'UI/UX Designer',
      technologies: ['Figma', 'Adobe XD']
    },
    {
      id: 5,
      job_description: 'Need a Data Scientist for predictive modeling project. Python, scikit-learn, and TensorFlow needed.',
      duration: '8 months',
      budget: 80,
      interview_rounds: 3,
      rounds: [
        { name: 'Stats & ML', duration: '1 hour' },
        { name: 'Coding', duration: '1 hour' },
        { name: 'Culture Fit', duration: '30 mins' }
      ],
      selectedResources: [
        { id: 'r5', name: 'Priya', designation: 'Senior Python Developer', cost_per_hour: 90, image: null }
      ],
      availabilities: [
        { date: '2026-03-01', time: '11:00' }
      ],
      status: 'Interview Scheduled',
      created_at: '2026-02-05',
      role: 'Data Scientist',
      technologies: ['Python', 'TensorFlow', 'scikit-learn']
    }
  ]
  const [filters, setFilters] = useState({
    role: '',
    technology: '',
    minRate: '',
    maxRate: '',
    role: '',
    technology: '',
    minRate: '',
    maxRate: '',
    duration: '',
    sortBy: 'newest' // newest, oldest, budget_asc, budget_desc
  })

  // Derive unique options
  const roles = [...new Set(receivedRequests.map(r => r.role))].sort()
  const allTechnologies = [...new Set(receivedRequests.flatMap(r => r.technologies || []))].sort()
  const durations = [...new Set(receivedRequests.map(r => r.duration))].sort()

  const filteredRequests = receivedRequests.filter(req => {
    const matchRole = !filters.role || req.role === filters.role
    const matchTech = !filters.technology || (req.technologies && req.technologies.includes(filters.technology))

    // Simple Rate Parsing (assuming budget is a number or numeric string)
    const rate = Number(req.budget)
    const matchMinRate = !filters.minRate || rate >= Number(filters.minRate)
    const matchMaxRate = !filters.maxRate || rate <= Number(filters.maxRate)

    const matchDuration = !filters.duration || req.duration === filters.duration

    return matchRole && matchTech && matchMinRate && matchMaxRate && matchDuration
  }).sort((a, b) => {
    switch (filters.sortBy) {
      case 'oldest':
        return new Date(a.created_at) - new Date(b.created_at)
      case 'budget_asc':
        return Number(a.budget) - Number(b.budget)
      case 'budget_desc':
        return Number(b.budget) - Number(a.budget)
      case 'newest':
      default:
        return new Date(b.created_at) - new Date(a.created_at)
    }
  })

  const stats = {
    total: receivedRequests.length,
    pending: receivedRequests.filter(req => req.status === 'Pending').length,
    accepted: receivedRequests.filter(req => req.status === 'Accepted').length,
    scheduled: receivedRequests.filter(req => req.status === 'Interview Scheduled').length
  }

  const handleView = (req) => {
    setSelectedRequest(req)
    setViewModalOpen(true)
  }

  const handleDownloadPO = (req) => {
    // Mock download functionality
    toast.success(`Downloading Purchase Order for Request #${req.id}...`)

    // Create a mock text file download
    const element = document.createElement("a");
    const file = new Blob([`Purchase Order for Request #${req.id}\nDuration: ${req.duration}\nBudget: $${req.budget}/hr\nDate: ${new Date().toLocaleDateString()}`], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = `PO_Request_${req.id}.txt`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    document.body.removeChild(element);
  }

  const handleInterview = (req) => {
    setSelectedRequest(req)
    setInterviewModalOpen(true)
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-secondary-900">Received Requests</h1>
          <p className="text-secondary-600 mt-1">Manage all talent requests received from clients</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <div className="p-3 bg-blue-50 text-blue-600 rounded-lg">
            <FileText className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Total Requests</p>
            <p className="text-2xl font-bold text-gray-900">{stats.total}</p>
          </div>
        </div>

        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <div className="p-3 bg-yellow-50 text-yellow-600 rounded-lg">
            <Clock className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Pending</p>
            <p className="text-2xl font-bold text-gray-900">{stats.pending}</p>
          </div>
        </div>

        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <div className="p-3 bg-green-50 text-green-600 rounded-lg">
            <CheckCircle className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Accepted</p>
            <p className="text-2xl font-bold text-gray-900">{stats.accepted}</p>
          </div>
        </div>

        <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm flex items-center gap-4 transition-all hover:shadow-md">
          <div className="p-3 bg-purple-50 text-purple-600 rounded-lg">
            <Video className="w-6 h-6" />
          </div>
          <div>
            <p className="text-sm text-gray-500 font-medium">Interviews</p>
            <p className="text-2xl font-bold text-gray-900">{stats.scheduled}</p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 space-y-4">
        <div className="flex items-center gap-2 mb-2">
          <Filter className="w-4 h-4 text-primary-600" />
          <h3 className="text-sm font-semibold text-gray-700">Filters</h3>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

          {/* Role Filter */}
          <div className="relative">
            <select
              value={filters.role}
              onChange={(e) => setFilters(prev => ({ ...prev, role: e.target.value }))}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-lg text-sm appearance-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">All Roles</option>
              {roles.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
            <Briefcase className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <ChevronDown className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          </div>

          {/* Technology Filter */}
          <div className="relative">
            <select
              value={filters.technology}
              onChange={(e) => setFilters(prev => ({ ...prev, technology: e.target.value }))}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-lg text-sm appearance-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">All Tech</option>
              {allTechnologies.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
            <Filter className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <ChevronDown className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          </div>

          {/* Duration Filter */}
          <div className="relative">
            <select
              value={filters.duration}
              onChange={(e) => setFilters(prev => ({ ...prev, duration: e.target.value }))}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-lg text-sm appearance-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="">All Durations</option>
              {durations.map(d => <option key={d} value={d}>{d}</option>)}
            </select>
            <Clock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <ChevronDown className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          </div>

          {/* Rate Range */}
          <div className="flex items-center gap-2">
            <div className="relative flex-1">
              <input
                type="number"
                placeholder="Min Rate"
                value={filters.minRate}
                onChange={(e) => setFilters(prev => ({ ...prev, minRate: e.target.value }))}
                className="w-full pl-7 pr-2 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <DollarSign className="w-3 h-3 text-gray-400 absolute left-2 top-1/2 -translate-y-1/2" />
            </div>
            <span className="text-gray-400">-</span>
            <div className="relative flex-1">
              <input
                type="number"
                placeholder="Max Rate"
                value={filters.maxRate}
                onChange={(e) => setFilters(prev => ({ ...prev, maxRate: e.target.value }))}
                className="w-full pl-7 pr-2 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary-500 focus:border-transparent"
              />
              <DollarSign className="w-3 h-3 text-gray-400 absolute left-2 top-1/2 -translate-y-1/2" />
            </div>
          </div>

          {/* Clear Filters */}
          <button
            onClick={() => {
              setFilters({
                role: '',
                technology: '',
                minRate: '',
                maxRate: '',
                duration: ''
              })
            }}
            className="flex items-center justify-center gap-2 w-full px-4 py-2 text-red-600 bg-red-50 border border-red-100 rounded-lg text-sm hover:bg-red-100 transition-colors sm:col-span-2 md:col-start-1"
          >
            <X className="w-4 h-4" />
            Clear Filters
            Clear Filters
          </button>

          {/* Sort By */}
          <div className="relative">
            <select
              value={filters.sortBy}
              onChange={(e) => setFilters(prev => ({ ...prev, sortBy: e.target.value }))}
              className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 rounded-lg text-sm appearance-none focus:ring-2 focus:ring-primary-500"
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="budget_desc">Budget: High to Low</option>
              <option value="budget_asc">Budget: Low to High</option>
            </select>
            <Clock className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <ChevronDown className="w-4 h-4 text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          </div>

        </div>
      </div>
      <div className="space-y-4">
        {filteredRequests.map((req) => (
          <div key={req.id} className="border border-gray-200 rounded-lg p-5 hover:border-primary-200 transition-colors shadow-sm">
            <div className="flex items-start justify-between mb-3">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <h4 className="font-semibold text-secondary-900 text-lg">Request #{req.id}</h4>
                  <span className={`px-2 py-0.5 rounded text-xs font-medium border ${req.status === 'Pending' ? 'text-yellow-700 bg-yellow-50 border-yellow-200' :
                    req.status === 'Accepted' ? 'text-green-700 bg-green-50 border-green-200' :
                      req.status === 'Interview Scheduled' ? 'text-purple-700 bg-purple-50 border-purple-200' :
                        'text-blue-700 bg-blue-50 border-blue-200'
                    }`}>
                    {req.status}
                  </span>
                </div>
                <p className="text-secondary-600 text-sm line-clamp-2">{req.job_description}</p>
              </div>
              <div className="text-xs text-secondary-500 whitespace-nowrap">
                {req.created_at}
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-secondary-600 mb-4 mt-4">
              <div className="flex items-center">
                <DollarSign className="w-4 h-4 mr-2 text-secondary-400" />
                <span className="font-medium">{req.budget}/hr</span>
              </div>
              <div className="flex items-center">
                <Calendar className="w-4 h-4 mr-2 text-secondary-400" />
                <span>{req.duration}</span>
              </div>
              <div className="flex items-center">
                <Briefcase className="w-4 h-4 mr-2 text-secondary-400" />
                <span>{req.interview_rounds} Rounds</span>
              </div>
            </div>

            {/* Rounds Details */}
            {req.rounds && req.rounds.length > 0 && (
              <div className="mb-4 bg-gray-50 p-3 rounded-md">
                <p className="text-xs font-semibold text-secondary-700 mb-2">Interview Structure:</p>
                <div className="flex flex-wrap gap-2">
                  {req.rounds.map((r, i) => (
                    <span key={i} className="text-xs bg-white border px-2 py-1 rounded text-secondary-600">
                      {r.name} ({r.duration})
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Selected Resources */}
            {req.selectedResources && req.selectedResources.length > 0 && (
              <div className="mb-4">
                <p className="text-xs font-semibold text-secondary-700 mb-2">Selected Bench Resources:</p>
                <div className="flex flex-wrap gap-2">
                  {req.selectedResources.map((resource, i) => (
                    <div key={i} className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-blue-50 text-blue-800 text-xs border border-blue-100">
                      {resource.image ? (
                        <img src={resource.image} alt="" className="w-5 h-5 rounded-full" />
                      ) : (
                        <div className="w-5 h-5 bg-blue-200 rounded-full flex items-center justify-center text-[10px] font-bold">
                          {resource.name.charAt(0)}
                        </div>
                      )}
                      <div>
                        <div className="font-medium">{resource.name}</div>
                        <div className="text-[10px] opacity-80">{resource.designation}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Action Buttons */}
            <div className="flex items-center gap-3 mt-5 pt-3 border-t border-gray-100">
              <button
                onClick={() => handleView(req)}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-primary-600 bg-primary-50 rounded-md hover:bg-primary-100 transition-colors"
              >
                <Eye className="w-3.5 h-3.5" />
                View
              </button>
              <button
                onClick={() => handleDownloadPO(req)}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-md hover:bg-slate-200 transition-colors"
              >
                <Download className="w-3.5 h-3.5" />
                Download PO
              </button>
              <button
                onClick={() => handleInterview(req)}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-purple-600 bg-purple-50 rounded-md hover:bg-purple-100 transition-colors"
              >
                <Video className="w-3.5 h-3.5" />
                Interview
              </button>
            </div>
          </div>
        ))}
      </div>


      {/* View Modal */}
      <Modal
        isOpen={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        title={`Request #${selectedRequest?.id} Details`}
        size="lg"
      >
        {selectedRequest && (
          <div className="space-y-6">
            <div>
              <h4 className="text-sm font-semibold text-secondary-500 mb-1">Job Description</h4>
              <p className="text-secondary-900 bg-gray-50 p-3 rounded-lg border border-gray-100">
                {selectedRequest.job_description}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
                <h4 className="text-xs font-semibold text-secondary-500 mb-1">Duration</h4>
                <p className="text-sm font-medium text-secondary-900 flex items-center gap-2">
                  <Calendar className="w-4 h-4 text-slate-400" /> {selectedRequest.duration}
                </p>
              </div>
              <div className="bg-slate-50 p-3 rounded-lg border border-slate-100">
                <h4 className="text-xs font-semibold text-secondary-500 mb-1">Budget</h4>
                <p className="text-sm font-medium text-secondary-900 flex items-center gap-2">
                  <DollarSign className="w-4 h-4 text-slate-400" /> {selectedRequest.budget}/hr
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-500 mb-2">Interview Structure</h4>
              <div className="bg-white border rounded-lg overflow-hidden">
                <table className="w-full text-sm text-left">
                  <thead className="bg-gray-50 text-gray-500 font-medium">
                    <tr>
                      <th className="px-4 py-2">Round Type</th>
                      <th className="px-4 py-2">Duration</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {selectedRequest.rounds?.map((r, i) => (
                      <tr key={i}>
                        <td className="px-4 py-2 text-gray-900">{r.name}</td>
                        <td className="px-4 py-2 text-gray-600">{r.duration}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-500 mb-2">Selected Candidates</h4>
              <div className="space-y-2">
                {selectedRequest.selectedResources?.map((res, i) => (
                  <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold shrink-0">
                        {res.name.charAt(0)}
                      </div>
                      <div>
                        <h5 className="text-sm font-medium text-gray-900">{res.name}</h5>
                        <p className="text-xs text-gray-500">{res.designation}</p>
                      </div>
                    </div>

                    <div>
                      {(selectedRequest.status === 'Pending' || selectedRequest.status === 'Reviewed') && (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                          Pending
                        </span>
                      )}

                      {selectedRequest.status === 'Accepted' && (
                        <div className="flex flex-col items-end gap-2">
                          <button
                            className="flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors text-xs font-medium"
                          >
                            <Video className="w-3.5 h-3.5" />
                            Schedule Interview
                          </button>
                        </div>
                      )}

                      {selectedRequest.status === 'Interview Scheduled' && (
                        <div className="flex flex-col items-end gap-2">
                          <a
                            href="https://meet.google.com/mock-link"
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-1.5 px-3 py-1.5 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-xs font-medium"
                          >
                            <Video className="w-3.5 h-3.5" />
                            Join Interview
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="flex justify-end pt-4 border-t">
              <button
                onClick={() => setViewModalOpen(false)}
                className="px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Interview Modal */}
      <Modal
        isOpen={interviewModalOpen}
        onClose={() => setInterviewModalOpen(false)}
        title={selectedRequest?.status === 'Accepted' || selectedRequest?.status === 'Interview Scheduled' ? "Scheduled Interviews" : "Interview Status"}
        size="md"
      >
        {selectedRequest && (
          <div className="space-y-4">
            {(selectedRequest.status === 'Pending' || selectedRequest.status === 'Reviewed') ? (
              <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-100 flex flex-col items-center justify-center text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mb-3">
                  <Calendar className="w-6 h-6 text-yellow-600" />
                </div>
                <h3 className="text-lg font-semibold text-yellow-900 mb-1">Interview Pending</h3>
                <p className="text-sm text-yellow-700">
                  This request is currently under review. Interviews can be scheduled once the request is accepted.
                </p>
              </div>
            ) : (
              <div className="bg-purple-50 p-4 rounded-lg border border-purple-100">
                <h3 className="text-sm font-semibold text-purple-900 mb-3">Upcoming Schedules</h3>
                {selectedRequest.availabilities && selectedRequest.availabilities.length > 0 ? (
                  <div className="space-y-2">
                    {selectedRequest.availabilities.map((slot, idx) => (
                      <div key={idx} className="flex items-center gap-3 p-3 bg-white rounded border border-purple-100 shadow-sm">
                        <Calendar className="w-5 h-5 text-purple-500" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">
                            {new Date(slot.date).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                          </p>
                          <p className="text-xs text-purple-600 font-medium">
                            Time: {slot.time}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500 italic">No interview slots scheduled yet.</p>
                )}
              </div>
            )}

            <div className="flex justify-end pt-2">
              <button
                onClick={() => setInterviewModalOpen(false)}
                className="px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg text-sm font-medium transition-colors"
              >
                Done
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div >
  )
}

export default JobPosting